import type { ISortCriteria } from "@/lib/shared/types/pagination";

type ProductPriceFilterKey = {
  countryCode?: string;
  currencyCode: string;
  maxPrice: number;
};

/**
 * TanStack Query keys for products
 */
export const productKeys = {
  all: ["products"] as const,
  lists: () => [...productKeys.all, "list"] as const,
  list: (
    labels: string[],
    locale: string,
    page?: number,
    sort?: ISortCriteria,
    priceFilter?: ProductPriceFilterKey,
  ) => [...productKeys.lists(), labels, locale, page, sort, priceFilter] as const,
  details: () => [...productKeys.all, "detail"] as const,
  detail: (sku: string, locale: string) => [...productKeys.details(), sku, locale] as const,
  search: (query: string, locale: string) => [...productKeys.all, "search", query, locale] as const,
};
